import ShortLinkRedirect, {
  PATH as SHORT_LINK_REDIRECT,
} from './ShortLinkRedirect'

export const PATH = { SHORT_LINK_REDIRECT }

export default ShortLinkRedirect
